import React, { useEffect, useState } from "react";
import PopupWrapper from "../../../components/PopupWrapper";
import ErrorBoundary from "../../../components/ErrorBoundary";
import FormBox from "../../../components/FormBox/FormBox";
import { LoadingButton, SpinnerBlock } from "../../../Utils/CustomComponent";
import { useForm } from "react-hook-form";
import { insuranceExpiryFormSchema } from "../../../Utils/formOptions";
import { toast } from "react-toastify";
import { commonToast } from "../../../Utils";
import urls from "../../../Utils/urls";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../axios";
import { selected_authentication_server } from "../../../deployment-config";
import { InfoCircleFill } from "react-bootstrap-icons";
import useBorrowerDashboardTwo from "./apis/useBorrowerDashboardTwo";
import { loadingTypes } from "../../../Utils/constant";
import { fetchBorrowerInsuranceExpiringWithIn30Days } from "../../../store/reducers/dashboardSlice/api";
import CommonGrid from "../../../components/CommonGrid";
import { gridColumns_InsuranceExpiringWithin30Days } from "../../../Utils/TableColumnDefs";

const headers = {
  headers: {
    "Content-Type": "application/json",
    Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
  },
};

const InsuranceExpiringWithIn30Days = () => {
  const [showInsuranceExpiry, setShowInsuranceExpiry] = useState(false);
  const [showTableModal, setShowTableModal] = useState(false);

  const data = useSelector(
    (state) => state.dashboard.borrowerInsuranceExpiringWithIn30Days.data
  );
  const status = useSelector(
    (state) => state.dashboard.borrowerInsuranceExpiringWithIn30Days.status
  );
  const { activeAccountList } = useBorrowerDashboardTwo();
  const dispatch = useDispatch();

  const options = data?.map((el) => ({
    label: el.account,
    value: el.account,
  }));

  const requestedBody = {
    RecID: activeAccountList?.map((el) => el.value).join(" "),
  };

  useEffect(() => {
    if (status === loadingTypes.idle && activeAccountList?.length) {
      dispatch(
        fetchBorrowerInsuranceExpiringWithIn30Days({
          requestedBody,
          headers,
        })
      );
    }
  }, [status, dispatch, activeAccountList]);

  return (
    <div className="card h-100 shadow-sm p-3 border border-primary insuranceExpiring">
      {status === loadingTypes.fulfilled ? (
        <div className="card-body d-flex flex-column">
          <div
            role="button"
            onClick={() => setShowTableModal(true)}
            className="clickable-card-ach"
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="card-title mb-0">Insurance Expiring</h5>
              <span
                className="text-muted"
                data-bs-toggle="tooltip"
                title="Loans with insurance policies expiring in the next 30 days."
              >
                <InfoCircleFill />
              </span>
            </div>
            <p className="text-muted small mb-2">Within 30 Days</p>
            <h2>{data?.length}</h2>
          </div>
          <div className="mt-auto">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => setShowInsuranceExpiry(true)}
            >
              Upload Insurance
            </button>
          </div>
        </div>
      ) : status === loadingTypes.loading ? (
        <div className="m-5">
          <SpinnerBlock height="5vh" />
        </div>
      ) : null}
      <InsuranceExpiryModal
        show={showInsuranceExpiry}
        setShow={setShowInsuranceExpiry}
        options={options}
        data={data}
      />
      <InsuranceExpiringWithIn30DaysModal
        show={showTableModal}
        setShow={setShowTableModal}
        data={data}
        status={status}
      />
    </div>
  );
};

export default InsuranceExpiringWithIn30Days;

const InsuranceExpiryModal = ({ show, setShow, options, data }) => {
  const [disableBtn, setDisableBtn] = useState(false);

  const {
    handleSubmit,
    register,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm(insuranceExpiryFormSchema);
  const selectedRole = useSelector((s) => s.account.selectedRole.value);

  const loanNumber = watch("loan_number");
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));

  const handleAttachmentSubmit = (incident_number, incidentId, file) => {
    const toastId = toast.loading("Document upload in progress..."),
      sanitizedFileName = file.name.replace(/ /g, "_"),
      formData = new FormData();
    formData.append("document", file, sanitizedFileName);
    formData.append("incident_number", incident_number);
    formData.append("created_by", userDetails);

    axiosInstance
      .post(urls.support.postUploadAttachments, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.status === 200)
          axiosInstance.post(
            selected_authentication_server.ticket_attachment.endpoint,
            {
              incident_name: incident_number,
              filename: res.data.filename,
              incident_id: incidentId,
              mime_type: file.type,
              comment: "",
              created_by: userDetails.email,
            },
            selected_authentication_server.ticket_attachment.headers
          );
        toast.update(toastId, {
          render: "Document Uploaded Successfully",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        close();
      })
      .catch((err) => {
        console.error(err);
        toast.update(toastId, {
          render: "SOME ERROR OCCURED",
          type: "error",
          isLoading: false,
          ...commonToast,
        });
      })
      .finally(() => setTimeout(() => toast.dismiss(), 3000));
  };

  async function onSubmit(data) {
    if (!data.attachment?.size)
      return toast.error("File attachment is mandatory", commonToast);

    try {
      setDisableBtn(true);
      Object.assign(data, {
        subject: `Insurance upload for loan account ${data.loan_number}`,
        incident_description: `Insurance upload for loan account ${data.loan_number}`,
        user_id: `${userDetails.user_id}`,
        contact_email: userDetails.email,
        status_id: "1",
        role_type: selectedRole,
        severity_id: "",
        urgency_id: "",
        department_id: "3",
        category_id: "69778577545796163337988206301027129293",
      });
      axiosInstance
        .post(urls.support.postTicket(), data, { headers: jsonHeaders })
        .then(({ data: resData }) => {
          const { incident_number } = resData;
          if (incident_number) {
            const incident_id = JSON.parse(resData.incident_id).incident_id;
            handleAttachmentSubmit(
              incident_number,
              incident_id,
              data.attachment
            );
          }
        })
        .catch(console.error);
    } catch (error) {
      console.error(error);
    } finally {
      setDisableBtn(false);
    }
  }

  function close() {
    setShow(false);
    setValue("property_address", "");
    reset();
  }

  return (
    <div>
      <PopupWrapper
        Component={
          <ErrorBoundary>
            <div>
              <FormBox
                options={insuranceExpiryArr(options, data, loanNumber)}
                register={register}
                watch={watch}
                setValue={setValue}
                errors={errors}
              />
              <div>
                <LoadingButton
                  type="button"
                  className="btn btn-primary mt-3 text-white"
                  onClick={handleSubmit(onSubmit)}
                  title={"Submit"}
                  disabled={disableBtn}
                  loading={disableBtn}
                />
              </div>
            </div>
          </ErrorBoundary>
        }
        title="Upload Insurance"
        extraClass=""
        toShow={show}
        closeEventHandler={close}
      />
    </div>
  );
};

const insuranceExpiryArr = (options, data, loanNumber) => {
  return [
    {
      title: "Loan Number",
      field: "loan_number",
      type: "select",
      className: "col-6 py-4",
      options: options,
    },
    {
      title: "Property Address",
      field: "property_address",
      type: "text",
      className: "col-6 py-4",
      defaultValue: loanNumber
        ? data?.filter((el) => el.account === loanNumber)?.[0]?.property_address
        : "",
      disable: true,
    },
    {
      title: "Attachment",
      field: "attachment",
      type: "file",
      className: "col-12 py-4",
    },
  ];
};

const jsonHeaders = {
  "Content-Type": "application/json",
  Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
  maxBodyLength: Infinity,
};

const InsuranceExpiringWithIn30DaysModal = ({
  show,
  setShow,
  status,
  data,
}) => {
  return (
    <PopupWrapper
      Component={
        <ErrorBoundary>
          <CommonGrid
            status={status}
            className={``}
            title={"Insurance Expiring Within 30 Days"}
            gridColumns={gridColumns_InsuranceExpiringWithin30Days}
            columnData={data}
            viewAllModal={false}
          />
        </ErrorBoundary>
      }
      title={"Insurance Expiring Within 30 Days"}
      toShow={show}
      closeEventHandler={() => {
        setShow(false);
      }}
    />
  );
};
